export default __webpack_public_path__ + "static/media/background-buy.06af5b61.jpg";